import {
  QuestionMarkCircleIcon,
  ShoppingBagIcon,
  AmphoraFillIcon,
} from '@grupoboticario/flora-react-icons';

import { Link, ResponsiveFloraTypography } from 'ui/components';
import config from 'config';

import Styles from './Login.components.styles';

export const InfoUtilLinks = () => {
  const isEud = config.app.short === 'eud';

  return (
    <Styles.InfoUtilsWrapper gap="$2">
      <Link to="/perguntas-frequentes">
        <Styles.InfoUtilCard
          padded
          variant="interactive"
          autotagging-flora="on"
          data-flora-text="solicitar-ajuda"
          data-flora="button"
        >
          <QuestionMarkCircleIcon color="$actionableDefault" />
          <ResponsiveFloraTypography
            fontSize="bodySmallShort"
            fontWeight="medium"
            color="$statusAlertNonInteractivePredominant"
          >
            Solicitar ajuda
          </ResponsiveFloraTypography>
        </Styles.InfoUtilCard>
      </Link>
      <Link to={config.signup.site} target="_blank">
        <Styles.InfoUtilCard
          variant="interactive"
          autotagging-flora="on"
          data-flora-text={`quero-ser-${config.communication.userNamingConvention.singular.toLocaleLowerCase()}`}
          data-flora="button"
        >
          {isEud ? (
            <ShoppingBagIcon color="$actionableDefault" />
          ) : (
            <AmphoraFillIcon color="$actionableDefault" />
          )}

          <ResponsiveFloraTypography
            fontSize="bodySmallShort"
            fontWeight="medium"
            color="$statusAlertNonInteractivePredominant"
          >
            Quero ser <br />
            {config.communication.userNamingConvention.singular.toLocaleLowerCase()}
          </ResponsiveFloraTypography>
        </Styles.InfoUtilCard>
      </Link>
    </Styles.InfoUtilsWrapper>
  );
};
